import React, { Component } from "react";
import { Card, Container, Row, Col, Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import { LotSmartActions, SuperAdminAction } from "../../Actions";
import Loader from "../Loader/Loader";
import { findBySearch, scroolToTop, tableHeightScrollBars } from "../helper";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import PropertDetails from "../LandingPage/PropertySelection";
import DatePicker from "react-datepicker";
import moment from "moment";
import isEqual from "lodash/isEqual";

class AuditLotSmart extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date();
    endDate.setHours(23, 59, 59);
    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() - 30);

    this.state = {
      loader: false,
      searchValue: "",
      finalTableHeight: 0,
      auditList: [],
      searchedList: [],
      startDate,
      endDate,
      selectedProperty: "",
      PropertyId: this.props.PropertyId,
      timezone: this.props.timezone,
    };

    this.customStyles = {
      rows: { style: { minHeight: "50px" } },
      headCells: { style: { paddingLeft: "8px", paddingRight: "8px" } },
      cells: { style: { paddingLeft: "8px", paddingRight: "8px" } },
    };

    this.columns = [
      {
        name: "Time",
        sortable: true,
        width: "160px",
        selector: (r) => r.created_at,
        cell: (r) => <span>{r.created_at ? moment(r.created_at).format("YYYY-MM-DD HH:mm:ss") : "—"}</span>,
      },
      { name: "IP", width: "130px", selector: (r) => r.remote_ip || "—" },
      { name: "Method", width: "80px", selector: (r) => r.method || "—" },
      { name: "MID", width: "120px", selector: (r) => r.parsed_mid || "—" },
      { name: "TID", width: "120px", selector: (r) => r.parsed_tid || "—" },
      { name: "Merchant ID", width: "110px", selector: (r) => r.merchant_id ?? "—" },
      {
        name: "Status",
        width: "80px",
        cell: (r) => (
          <span className={`badge bg-${r.http_status === 200 ? "success" : "danger"}`}>
            {r.http_status ?? "—"}
          </span>
        ),
        selector: (r) => r.http_status,
      },
      { name: "Duration (ms)", width: "120px", selector: (r) => r.duration_ms ?? "—" },
      {
        name: "Error",
        grow: 2,
        selector: (r) => r.error_message || "—",
        wrap: true,
      },
    ];
  }

  componentDidMount = async () => {
    await this.fetchLogs();
    const tableHeight = tableHeightScrollBars();
    this.setState({ finalTableHeight: tableHeight });
  };

  componentDidUpdate = async (prevProps) => {
    if (!isEqual(prevProps.auditLogs, this.props.auditLogs)) {
      this.setState({ auditList: this.props.auditLogs, searchedList: [] });
    }
  };

  fetchLogs = async () => {
    const { startDate, endDate, selectedProperty } = this.state;
    this.setState({ loader: true });
    await this.props.getLotSmartAuditLogs({
      startDate: moment(startDate).utc().format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(endDate).utc().format("YYYY-MM-DD HH:mm:ss"),
      property_id: selectedProperty || undefined,
      limit: 500,
    });
    this.setState({ loader: false });
  };

  handleSearch = (value) => {
    const { auditList } = this.state;
    this.setState({ searchValue: value });
    if (!value) {
      this.setState({ searchedList: [] });
      return;
    }
    const fields = ["remote_ip", "parsed_mid", "parsed_tid", "method", "error_message"];
    const filtered = findBySearch(value, auditList, auditList, fields);
    this.setState({ searchedList: filtered });
  };

  handlePropertyChange = (propertyObj) => {
    this.setState({ selectedProperty: propertyObj?.id || "", selectedPropertyObj: propertyObj });
  };

  render() {
    const { loader, searchValue, finalTableHeight, auditList, searchedList, startDate, endDate } = this.state;
    const displayList = searchedList.length > 0 ? searchedList : auditList;

    return (
      <Container fluid>
        {loader && <Loader />}

        <Row className="mb-3">
          <Col>
            <h4 className="mb-0">Audit LotSmart</h4>
            <small className="text-muted">API request log from LotSmart devices</small>
          </Col>
        </Row>

        <Card className="mb-3">
          <Card.Body>
            <Row className="align-items-end">
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="d-block">Property</Form.Label>
                <PropertDetails
                  selectedPropertyObj={this.state.selectedPropertyObj}
                  onChangeProperty={this.handlePropertyChange}
                  placeholder="All Properties"
                  {...this.props}
                />
              </Col>
              <Col xs={6} md={3} className="mb-2">
                <Form.Label className="d-block">Start Date</Form.Label>
                <DatePicker
                  className="form-control"
                  selected={startDate}
                  onChange={(d) => this.setState({ startDate: d })}
                  dateFormat="yyyy-MM-dd"
                  maxDate={endDate}
                />
              </Col>
              <Col xs={6} md={3} className="mb-2">
                <Form.Label className="d-block">End Date</Form.Label>
                <DatePicker
                  className="form-control"
                  selected={endDate}
                  onChange={(d) => this.setState({ endDate: d })}
                  dateFormat="yyyy-MM-dd"
                  minDate={startDate}
                />
              </Col>
              <Col xs={12} md={2} className="mb-2">
                <Button onClick={this.fetchLogs} className="w-100">
                  Search
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card>
          <Card.Body>
            <DatatableHeader
              Header="LotSmart Request Log"
              searchValue={searchValue}
              onChange={this.handleSearch}
            />
            <DataTable
              columns={this.columns}
              data={displayList}
              customStyles={this.customStyles}
              pagination
              paginationPerPage={50}
              paginationRowsPerPageOptions={[25, 50, 100, 200]}
              fixedHeader
              fixedHeaderScrollHeight={`${finalTableHeight}px`}
              noDataComponent="No audit log records found"
              dense
            />
          </Card.Body>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = ({ UserProfileDetails, LotSmartDetails }) => ({
  PropertyId: UserProfileDetails.property_id,
  timezone: UserProfileDetails.timezone,
  auditLogs: LotSmartDetails.auditLogs,
  auditCount: LotSmartDetails.auditCount,
});

const mapDispatchToProps = {
  getLotSmartAuditLogs: LotSmartActions.getLotSmartAuditLogs,
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditLotSmart);
